/*
*###############################################################################
*Module Name                   : VoucherTransferInController.js                #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Thursday, January 6th 2022, 9:53:19 am        #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
const getLocationDets = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations/select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherGroup = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGroup`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}



const getVoucherBook = async (Category, Location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  console.log(Category)
  await fetch(`${ApiURL}VoucherTRO/GetBookList/${Category}/${Location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getVoucherNumber = async (Category, Location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  console.log(Category)
  await fetch(`${ApiURL}VoucherTRO/GetVoucherNumberList/${Category}/${Location}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
// Voucher Group save method
const setVoucherSave = async (
  strVoucherCode,
  strVoucherDate,
  LocationCode,
  LogCompanyCode,
  strFromLocation,
  strToLocation,
  strRemarks1,
  strRemarks2,
  strRefNo,
  LogUserType,
  menuCode,
  LogCompanyCodenew,
  LocationCodenew,
  strReason,
  VoucherPoDet

) => {
  var myHeaders = new Headers()
  const authToken = localStorage.getItem("authToken")
  myHeaders.append("Authorization", `Bearer ${authToken}`)
  myHeaders.append("Content-Type", "application/json")

  var raw = JSON.stringify({
    strType: 'VTI',
    strRunNo: strVoucherCode,
    dtTxnDate: strVoucherDate,
    dtTxnTime: strVoucherDate,
    strSetupLoc: LocationCode,
    strComCode: LogCompanyCode,
    strFromLocCode: strFromLocation,
    strToLocCode: strToLocation,
    strRef1: strRemarks1,
    strRef2: strRemarks2,
    strRefNo: strRefNo,
    strBatchNo: '',
    intHedProcess: 1,
    intHedCancelled: 0,
    dtCancellDate: '1900-01-01',
    strCancelldUser: '',
    dbPrintCount: 0,
    intHedFullyUsed: 1,
    intExport: 0,
    strExportBatch: '',
    strCreateBy: LogUserType,
    strMenuCode: menuCode,
    strLoggedCompany: LogCompanyCode,
    strLoggedLocation: LocationCode,
    strReason: LogCompanyCode,
    VCTRIDETAILS: VoucherPoDet

  })



  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  var data = [];
  await fetch(`${ApiURL}VoucherTRI`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}
const getVoucherTOSearch = async LocationCode => {
  console.log(LocationCode)
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRO/PendingTranferOut/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherTOHeader = async id => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/search/${id}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getVoucherPendingTOHeader = async (id, LocationCode) => {
  console.log(LocationCode)
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRI/Pendingsearch/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getVoucherTRISearch = async (LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRI/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherTRIHeader = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherTRI/search/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getCustomerData = async (searchcode) => {
  const authToken = localStorage.getItem("authToken");
  const ApiURL = window.Links.ApiURL;
  if (searchcode !== "") {

    try {
      const response = await fetch(`${ApiURL}Common/headOffice/customer/search/${searchcode}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const responseData = await response.json();

      if (responseData.success === true) {
        return responseData.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
      return []; // Return an empty array on error
    }
  }

  return []; // Return an empty array if searchcode is empty
};


const getSaleAssistantData = async (searchcode) => {
  const authToken = localStorage.getItem("authToken");

  if (searchcode !== "") {
    const ApiURL = window.Links.ApiURL;
    try {
      const response = await fetch(`${ApiURL}salesassistant/search/${searchcode}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const responseData = await response.json();

      if (responseData.success === true) {
        return responseData.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
      return []; // Return an empty array on error
    }
  }

  return []; // Return an empty array if searchcode is empty
};

async function fetchPriceModeData() {

  const authToken = localStorage.getItem("authToken");
  const ApiURL = window.Links.ApiURL;

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: 'follow'
  };

  try {
    const response = await fetch(`${ApiURL}pricemode/select`, requestOptions);
    const result = await response.json();
    return result.data;
  } catch (error) {
    console.log('error', error);
    return [];
  }
}


async function ValidateVouchers(groupCode, voucherFrom, voucherTo, strFromLocation) {

  const authToken = localStorage.getItem("authToken");
  const ApiURL = window.Links.ApiURL;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: 'follow',
    body: JSON.stringify({
      "voucherGroupCode": groupCode,
      "voucherFrom": voucherFrom ?? "",
      "voucherTo": voucherTo ?? "",
      "location": strFromLocation,
    })
  };

  try {
    const response = await fetch(`${ApiURL}VoucherSale/validateNumbers/headOffice`, requestOptions);
    const result = await response.json();
    return { success: result.success, message: result.message, rows: result.rowcount };
  } catch (error) {
    console.log('error', error);
    return { success: false, message: error, rows: "0" };
  }
}



async function SaveUpdateVouchers(data) {

  const authToken = localStorage.getItem("authToken");
  const ApiURL = window.Links.ApiURL;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: 'follow',
    body: JSON.stringify(data)
  };

  try {
    const response = await fetch(`${ApiURL}VoucherSale`, requestOptions);
    const result = await response.json();
    return { success: result.success, message: result.message };
  } catch (error) {
    console.log('error', error);
    return { success: false, message: error };
  }
}


// const getVoucherSale = async (documentNo, LocationCode) => {

//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")
//   var data = []
//   var requestOptions = {
//     method: "GET",
//     headers: {
//       "Authorization": `Bearer ${authToken}`
//     },
//     redirect: "follow",
//   }
//   await fetch(`${ApiURL}VoucherSale/headOffice/${documentNo}/${LocationCode}`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       data = result.data
//     })
//     .catch(error => console.log("error", error))
//   return data
// }
const getVoucherSale = async (documentNo, LocationCode) => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");
  let data = [];
  let isSuccess = false;

  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    redirect: "follow",
  };

  try {
    const response = await fetch(`${ApiURL}VoucherSale/headOffice/${documentNo}/${LocationCode}`, requestOptions);

    const result = await response.json();

    return { success: result.success, data: result.data };
  } catch (error) {
    console.error("Error:", error);
    return { success: false, data: {} };
    // You can add additional error handling logic here if needed
  }

  return data;
};


export {
  getLocationDets,
  getVoucherGroup,
  setVoucherSave,
  getVoucherTOSearch,
  getVoucherTOHeader,
  getVoucherTRISearch,
  getVoucherTRIHeader,
  getVoucherPendingTOHeader,
  getVoucherBook,
  getVoucherNumber,
  getCustomerData,
  getSaleAssistantData,
  fetchPriceModeData,
  ValidateVouchers,
  SaveUpdateVouchers,
  getVoucherSale
}